import { useState } from 'react';
import apiService from '../../axios/apiService';
import { saveAs } from 'file-saver';
import { getBlobFromBase64 } from '../../utils/file';

export const useDownloadRadiologistInvoicePreview = () => {
  const [loading, setLoading] = useState(false);
  const getPreview = async (invoiceId, invoiceNo) => {
    // Fetch case
    setLoading(true);
    try {
      const response = await apiService.downloadRadiologistInvoicePreview(invoiceId);
      if (response) {
        const blob = await getBlobFromBase64(response, 'application/pdf');
        saveAs(blob, `${invoiceNo}.pdf`);
      }
    } catch (error) {
      console.log('Error: ', error);
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    getPreview,
  };
};
